// extracted by mini-css-extract-plugin
module.exports = {"bar":"ProgressBar_bar__5gHYa","innerBar":"ProgressBar_innerBar__5glOP","text":"ProgressBar_text__3Inzz"};